import ptPopup from './src/popup.vue';

ptPopup.install = function(vue) {
    vue.component(ptPopup.name, ptPopup);
};

export default ptPopup;
